export default __webpack_public_path__ + "static/media/galaxy.fe8e1ed1.png";